import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../styled-base/modal';
import {searchMatchedTextValue} from '../../utils/common';
import Button from '../../styled-base/button';
import TextField from '../../styled-base/input/text';
import {useDispatch} from 'react-redux';
import {addCard} from '../actions/card.actions';
import BoardService from '../services/board.service';
import Avatar from '../../components/helper/avatar';

const noop = () => {};

const Row = ({item, isChecked, toggleChkBox}: any) => {
    return (
        <div>
        {typeof item.userId !== "undefined" ? (
          <div className="rectbox-row ">
            <div className="rectbox-col">
              <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
                <input
                  type="checkbox"
                  className="css-checkbox"
                  checked={isChecked}
                  value={item.userId}
                  name="items[]"
                  onChange={e => toggleChkBox(e, item)}
                  id={`item-chk-${item.userId}`}
                />
                <label
                  className="css-label modalParaText"
                  htmlFor={`item-chk-${item.userId}`}
                />
              </div>
            </div>
            <div className="rectbox-col">
                <Avatar 
                    src={item.userPic} 
                    imageClass="roundFramePhoto column-user-picture" 
                    useSpriteSheet={false} />
            </div>
            <div
              className="rectbox-col rectbox-col-goal rectbox-col-line"
              style={{ paddingLeft: "20px" }}
            >
              <div className="rectbox-title" data-testid="rectbox-title">
                <span>{`${item.firstName} ${item.lastName}`}</span>
              </div>
              <div className="rectbox-subtitle">{item.role}</div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    )
}


const AddColumnUserModal = ({columnId, data, onClose = noop}: any) => {
    const { t } = useTranslation();
    const defaultLists = data.userTeamList || [];
    const dispatch = useDispatch();
    const [lists, searchLists] = useState<any>(defaultLists);
    const [selectedItems, setSelectedItems] = useState<any>([]);
    const [text, searchText] = useState<string>();
    const [errorText, setErrorText] = useState<string>();
    const services = new BoardService();
    
    const addItem = async() => {
        console.log('addItem')
        if (!Array.isArray(selectedItems) || !selectedItems.length) {
            setErrorText(t('Please select atleast one item.'));
        }
        else {
            showLoaderWidget(document.getElementById('content'));
            const response = await services.saveBoardPeople({columnId, selPeople: selectedItems});
            const {data} = response.data;
            if (Array.isArray(data) && data.length) {
                dispatch(addCard(columnId, data));
            }
            removeLoader();
            onClose();
        }
    }

    const toggleChkBox = (e: any, item: any) => {
        const isChecked = e.target.checked;
        const value = e.target.value;
        if (isChecked) {
            setSelectedItems([...new Set([...selectedItems, value])]);
        }
        else {
            setSelectedItems(selectedItems.filter((v: any) => value != v));
        }
        console.log('toggleChkBox', selectedItems)
    }

    const onSearchText = (e:any) => {
        const value = e.target.value.trim();
        searchText(value);
        if (value) {
            searchLists(defaultLists.filter((v: any) => {
                const itemTitle = v.label.toLowerCase();
                const teamName =  typeof v.allTeamName !== "undefined"
                ? v.allTeamName.toLowerCase()
                : "";
                return (
                  searchMatchedTextValue(itemTitle, value) ||
                  searchMatchedTextValue(teamName, value)
                );
            }));
        } else {
            searchLists(lists);
        }
    }

    const renderRows = (rows: any) => {
        if (!Array.isArray(rows) || !rows.length) 
            return null;
    
        return rows.map((row: any, index: number) => 
                <Row 
                    key={`ws_${row.userId}`}
                    item={row}
                    isChecked={selectedItems.includes(row.userId)}
                    toggleChkBox={toggleChkBox}
                />
            )
    }

    return (
        <Modal width={500} classes='portal-modal-add-column-user'>
             <Modal.Header onClose={onClose}>
                <div>{t('Add a People')}</div>
            </Modal.Header>
            <Modal.Content>
                <div className="">
                    <div className="addwoboitem-text-wrapper">
                        <TextField
                            inputProps = {{
                                name: "s",
                                id: "sbox",
                                placeholder: t("Search by member or team name"),
                                style: {
                                    border: '1px solid #dce0e3',
                                    height: '37px',
                                    borderRadius: '3px',
                                    padding: '0px 5px 0px 5px',
                                    backgroundColor: 'rgba(204,204,204,.3)'
                                },
                                autoComplete: 'off'
                            }}
                            onChangeText = {onSearchText}
                        />
                        <div className="errormsg" 
                            style={{display: (errorText? 'block': 'none')}}>
                            {errorText}
                        </div>
                    </div>
                    <div className="addwoboitem-wrapper" data-testid="addwoboitem-wrapper">
                        {renderRows(lists)}
                    </div>  
                </div>
            </Modal.Content>
            <Modal.Footer>
                {
                defaultLists.length ? 
                    <Button type="primary" onClick={() => addItem()} >
                        {t('Add')}
                    </Button> : ''
                }
            </Modal.Footer>
        </Modal>
    )
}

export default AddColumnUserModal;